package com.writerslab.office

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.renderComposable

fun main() {
    renderComposable(rootElementId = "composeApp") {
        Root()
    }
}

private enum class AuthState { CHECKING, LOGGED_OUT, LOGIN_FAILED, READY }

@Composable
private fun Root() {
    var authState by remember { mutableStateOf(AuthState.CHECKING) }

    LaunchedEffect(Unit) {
        if (PREVIEW || NO_AUTH) { authState = AuthState.READY; return@LaunchedEffect }
        if ("code=" in kotlinx.browser.window.location.search) {
            Auth.handleCallback()
        }
        authState = when {
            !Auth.isLoggedIn -> AuthState.LOGGED_OUT
            !Auth.hasManagerRole() -> {
                Auth.clearTokens()
                AuthState.LOGIN_FAILED
            }
            else -> AuthState.READY
        }
    }

    when (authState) {
        AuthState.CHECKING -> CenterScreen { Text("Загрузка…") }
        AuthState.LOGGED_OUT -> LoginScreen(error = false)
        AuthState.LOGIN_FAILED -> LoginScreen(error = true)
        AuthState.READY -> App()
    }
}

@Composable
private fun LoginScreen(error: Boolean) {
    CenterScreen {
        Div({ style { property("display", "flex"); property("flex-direction", "column"); property("align-items", "center"); property("gap", "12px") } }) {
            Span({ style { fontSize(18.px); color(Color(C.OnSurface)) } }) { Text("Writers Lab Office") }
            if (error) {
                Span({ style { fontSize(13.px); color(Color(C.Error)) } }) { Text("Неверные данные. Попробуйте ещё раз.") }
            }
            Button({
                style { btn(); marginTop(4.px) }
                onClick { Auth.login() }
            }) { Text("Войти") }
        }
    }
}

@Composable
private fun CenterScreen(content: @Composable () -> Unit) {
    Div({
        style {
            backgroundColor(Color(C.Bg))
            property("min-height", "100vh")
            property("display", "flex")
            property("align-items", "center")
            property("justify-content", "center")
        }
    }) { content() }
}
